import { ModelBase } from '../../core/model/model-base';
import { User } from './user';
import { Contact } from './contact';
import { DialogMessageParticipantKind } from './const/enum';
import { Attachment } from './attachment';

export class DialogModel extends ModelBase {
  dialogMessages: DialogMessage[];
}

export class DialogMessage extends ModelBase {
  dialogId: string;
  header: string;
  text: string;
  showToTenant: boolean;
  isRead: boolean;
  attachments: DialogMessageAttachmentModel[];
  canMarkAsRead: boolean;
  canDeleteMessage: boolean;
  canMarkAsUnread: boolean;

  senderName: string;
  senderUserContact: Contact;
  senderUser: User;
  senderKind: DialogMessageParticipantKind;

  private _sendTime: Date;
  get sendTime(): Date {
    return this._sendTime;
  }
  set sendTime(value: Date) {
    this._sendTime = new Date(value);
  }

  readByUser: User | null;
  readByUserContact: Contact;
  readerKind: DialogMessageParticipantKind | null;

  private _readTime: Date | null;
  get readTime(): Date {
    return this._readTime;
  }
  set readTime(value: Date) {
    this._readTime = new Date(value);
  }
}

export class DialogMessageAttachmentModel extends Attachment {
  previewImage: string;
}

export class DialogMessageMarkAsReadModel {
  id: string;
}

export class DialogMessageMarkMessagesAsReadModel {
  ids: string[];
}

export class CreateDialogMessageModel {
  id: string;
  dialogId: string;
  header: string;
  text: string;
  showToTenant: boolean;
  attachments: File[];

  toJSON() {
    const json = Object.assign({}, this);
    return json;
  }
}

export class DialogUnreadMessagesModel {
  hasUnreadMessages: boolean;
}
